import api from 'service/index';
import { CONTEXT } from 'constants/url';
import { getUrlParam } from 'utils/urlUtils';
import { getToken } from 'modules/auth/selectors';
import { mergeContextWithToken } from 'modules/dealers/utils';

import type { RootState } from 'App/Store';
import { ContextResponse } from './types/ContextResponse';

const dealersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getContext: build.query<ContextResponse, void>({
      queryFn: async (_, { getState }, __, baseQuery) => {
        const token = getUrlParam('token') ?? getUrlParam('OSToken');

        const result = await baseQuery({
          method: 'GET',
          url: CONTEXT,
          params: token ? { token } : {},
        });

        if (result.error) {
          return { error: result.error };
        }

        let context = result.data as ContextResponse;
        const tokenToDecode = getToken(getState() as RootState);
        if (tokenToDecode) {
          context = mergeContextWithToken(context, tokenToDecode);
        }

        if (Array.isArray(context?.kioskDealers)) {
          const kioskDealersWithSortedBrands = context.kioskDealers.map((dealer) => ({
            ...dealer,
            brands: dealer.brands.sort(({ name: aName }, { name: bName }) => aName.localeCompare(bName)),
          }));
          const sortedBrands = context.brands?.sort(({ name: aName }, { name: bName }) => aName.localeCompare(bName));
          context = { ...context, kioskDealers: kioskDealersWithSortedBrands, brands: sortedBrands };
        }

        return { data: context };
      },
    }),
  }),
});

export const { useGetContextQuery } = dealersApi;

export default dealersApi;
